<template>
  <div class="practice-stats-secondary-info statssecinfo">
    <div
      v-for="(row, index) in items"
      :key="index"
      class="statssecinfo_item gw_box"
      style="--clr-box-back: var(--clr-black-2); --box-padding: var(--padding-item)"
    >
      <div
        class="mdi clr-grey csst mdi-help-circle-outline text-small"
        style="position: absolute; top: 0.25rem; right: 0.5rem; color: var(--clr-grey-2)"
        @mouseenter="e => fl_positionTooltip(e, { placement: 'bottom' })"
      >
        <div
          class="clr-white csst_content clr-white text-wrap"
          style="position: fixed; max-width: 22rem"
          v-html="row.tooltip"
        />
      </div>
      <div class="statssecinfo_item_name">
        {{ row.name }}
      </div>
      <div class="statssecinfo_item_values">
        <div
          v-for="(row, index) in row.rows"
          :key="index"
          class="statssecinfo_item_values_value"
        >
          <span class="statssecinfo_item_values_value_value">
            {{ row.value }}
          </span>
          <span
            class="statssecinfo_item_values_value_unit"
            style="padding-left: 0.25rem"
          >
            {{ row.unit }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'PracticeStatsSecondaryInfo',
  mixins: [format_mix, float_mix],
  props: {
    items: Array,
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.statssecinfo {
  --gap: 0.5rem;
  --padding-item: 0.75rem;
  --grid-template-columns: 1fr 1fr;

  --clr-name: var(--clr-grey-2);
  --size-name: 1rem;
  --weight-name: 500;
  --transform-name: none;

  --clr-value-value: var(--clr-white-0);
  --size-value-value: 0.8;
  --weight-value-value: 700;
  --transform-value-value: none;

  --clr-value-unit: var(--clr-grey-2);
  --size-value-unit: 0.8rem;
  --weight-value-unit: 500;
  --transform-value-unit: none;

  display: grid;
  grid-template-columns: var(--grid-template-columns);

  // flex-wrap: wrap;
  grid-gap: var(--gap);
  width: 100%;
  &_name {
  }
  &_item {
    flex: 1;
    &_name {
      font-size: var(--size-name);
      color: var(--clr-name);
      font-weight: var(--weight-name);
      text-transform: var(--transform-name);
      padding: 0 0.75rem 0 0;
    }
    &_values {
      margin: 0.25rem 0 0 0;
      &_value {
        &_value {
          font-size: var(--size-value-value);
          color: var(--clr-value-value);
          font-weight: var(--weight-value-value);
          text-transform: var(--transform-value-value);
        }
        &_unit {
          font-size: var(--size-value-unit);
          color: var(--clr-value-unit);
          font-weight: var(--weight-value-unit);
          text-transform: var(--transform-value-unit);
          font-style: italic;
        }
      }
    }
  }
}
</style>
